module.exports = __webpack_public_path__ + "static/favicon-eb57833abfc41cc6a7ff9954c23be2e5.png";